import { CdkDragDrop, moveItemInArray, transferArrayItem } from "@angular/cdk/drag-drop";
import { Component, ContentChild, EventEmitter, forwardRef, Input, Output, TemplateRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

import {
	StatusBoardColumn,
	StatusBoardColumnPaging,
	StatusBoardDropEvent,
	StatusBoardFormResult,
	StatusBoardItemStatus,
} from "../interfaces";

const INPUT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => StatusBoardInputComponent),
	multi: true,
};

@Component({
	selector: "ic-status-board-input",
	styleUrls: ["input.component.scss"],
	providers: [INPUT_CONTROL_ACCESSOR],
	templateUrl: "./input.component.html",
	standalone: false,
})
export class StatusBoardInputComponent implements ControlValueAccessor {
	protected disabled = false;
	protected items: StatusBoardFormResult = {};

	@Input() columns: StatusBoardColumn[] = [];
	@Input() paging: StatusBoardColumnPaging = {};

	@Output() dropEvent = new EventEmitter<StatusBoardDropEvent>();

	@ContentChild("itemTmpl", { static: false }) itemTemplate: TemplateRef<any>;
	@ContentChild("titleTmpl", { static: false }) titleTemplate: TemplateRef<any>;
	@ContentChild("pagingTmpl", { static: false }) pagingTemplate: TemplateRef<any>;

	private onTouch = () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
	// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
	private onModelChange = (_: unknown) => {};

	setDisabledState(isDisabled: boolean) {
		this.disabled = isDisabled;
	}

	onChange(event: CdkDragDrop<StatusBoardItemStatus[]>) {
		this.dropEvent.emit({
			previousContainer: event.previousContainer.id,
			currentContainer: event.container.id,
			previousIndex: event.previousIndex,
			currentIndex: event.currentIndex,
			item: event.item.data,
		});

		if (event.previousContainer === event.container) {
			moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
		} else {
			transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
		}

		this.onModelChange(this.items);
		this.onTouch();
	}

	writeValue(value: StatusBoardFormResult) {
		if (!value) {
			this.items = {};

			return;
		}

		this.items = {};

		// Make a copy of the individual arrays
		for (const column of Object.keys(value)) {
			this.items[column] = [...value[column]];
		}
	}

	alwaysAllowEnterPredicate() {
		return true;
	}

	registerOnChange(fn: (_: unknown) => void) {
		this.onModelChange = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouch = fn;
	}
}
